import React from 'react'
import DeviceMetricForm from 'pages/shared/DeviceMetricForm'

import { SinglePanePage } from 'styles/shared'

const deviceMetric = {
  id: '',
  name: '',
  color: '#000000',
  description: '',
  callToAction: [],
  draft: true,
  unit: '',
  sort: 0,
  charts: [],
  hasMetricStatuses: false,
  hasMetricValues: false,
  validatedSaveType: ''
}

const AddDeviceMetric = () => (
  <SinglePanePage>
    <DeviceMetricForm
      title="New Device Metric"
      validatedSaveType="create"
      deviceMetric={deviceMetric}
    />
  </SinglePanePage>
)

export default AddDeviceMetric
